import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ContentService } from 'src/app/shared/services/content/content.service';
import { content } from 'src/assets/content/fallback-content';

@Component({
  selector: 'disclosures-v4',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './disclosures-v4.component.html',
  styleUrl: './disclosures-v4.component.scss',
})
export class DisclosuresV4Component {
  content = content.Data.v4_rcc_root.content.disclosures;

  constructor(private readonly contentService: ContentService) {
    this.contentService.getContent().subscribe((data) => {
      this.content = data.Data.v4_rcc_root.content.disclosures;
    });
  }
}
